import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fb097516"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "videoProfileBox"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "link-content"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "yuque-icon"
}, "📚"), /*#__PURE__*/_createElementVNode("span", null, "查看完整课程大纲")], -1));
const _hoisted_4 = {
  key: 0,
  class: "password-tip"
};
// 模拟语雀数据
// const yuqueUrl = ref('https://www.yuque.com/xiaoniu663/gskg7m/xpkxnhlfwfazlicd?singleDoc#');
// const password = ref('reob');
// 如果需要通过props传入，保留这个接口
export default /*#__PURE__*/_defineComponent({
  __name: 'VideoProfile',
  props: {
    video: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.video.classLink ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _ctx.video.classLink,
        target: "_blank",
        class: "yuque-link"
      }, [_hoisted_3, _ctx.video.classLinkPassword ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 访问密码：" + _toDisplayString(_ctx.video.classLinkPassword), 1)) : _createCommentVNode("", true)], 8, _hoisted_2)) : _createCommentVNode("", true)]);
    };
  }
});